export default __webpack_public_path__ + "static/media/gced_details_PL.9227ba18.png";